import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./screens/Home";
import { Amplify } from "aws-amplify";
import amplifyConfig from "./amplifyconfiguration.json";
Amplify.configure(amplifyConfig);
const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
